import React from "react";

//external components
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProfileForm from "../../profile-form";
import PasswordForm from "../../password-form";
import EmployeePTOs from "../../../admin-configuration/Employees/EmployeePTOs";
import EmployeeSkills from "../../../admin-configuration/Employees/EmployeeSkills";
import EmployeeTeamsList from "../../../admin-configuration/Employees/Employee-teams";
import LoanedItems from "../../../admin-configuration/LoanedItems/LoanedItems-list";
import MyProjects from "../../../admin-configuration/MyProjectsProfile";

//components

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0.5, pb: 0.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ProfileTabRoutes({ value, fromTenant = false }) {
  return (
    <>
      <TabPanel value={value} index={0}>
        <ProfileForm fromTenant={fromTenant} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <EmployeePTOs fromTenant={fromTenant} fromProfile={true} />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <EmployeeSkills fromTenant={fromTenant} />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <PasswordForm fromTenant={fromTenant} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <EmployeeTeamsList fromTenant={fromTenant} fromProfile={true} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <LoanedItems fromTenant={fromTenant} fromProfile={true} />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <MyProjects fromTenant={fromTenant} fromProfile={true} />
      </TabPanel>
    </>
  );
}